/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { useTheme } from '@providers/theme';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { Header, UsersListComp } from '../components';

import { vappContainer } from '@/application';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import {
  useSMPolicyList,
  useSMProvisional,
} from '@pages/ProvisionalPage/machines';
import { ProvisionalPageService } from '@pages/ProvisionalPage/services';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import toast from 'react-hot-toast';
import { SearchFilter } from '../../../widgets/filter-widget-react';

const getSrv = () => {
  return vappContainer.get<ProvisionalPageService>(ProvisionalPageService.name);
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [refreshPagination, setRefreshPagination] = useState(new Date());
  const srv = getSrv();

  useEffect(() => {
    //srv?.resetCriteria();
  }, []);

  const { provisionalPageMachine, provisionalPageSend, provisionalPageState } =
    useSMProvisional({});

  const { policyListMachine, policyListState } = useSMPolicyList({});

  console.log('render page', provisionalPageState?.event?.data?.value);

  const onRefresh = () => {
    provisionalPageSend('TRIGGER_REFRESH', {});
    setRefreshPagination(new Date());
  };

  const onClearFilter = () => {
    // srv?.resetCriteria();
    Array.from(document.querySelectorAll('input')).forEach(
      (input) => (input.value = '')
    );
    provisionalPageSend('TRIGGER_REFRESH', {});
  };

  const _renderNotification = () => {
    return null;
  };

  const onPaginationChange = (event: any) => {
    provisionalPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const _renderPagination = () => {
    if (!provisionalPageState?.event?.data?.value?.isEmpty) {
      return (
        <Paginate
          {...(provisionalPageState?.event?.data?.value || {})}
          onPageChange={onPaginationChange}
          key={refreshPagination}
          totalItems={
            provisionalPageState?.event?.data?.value?.ultUsers?.length
          }
        />
      );
    }
  };

  const onApplyFilter = (data: any) => {
    console.log('apply clicked', data);
    let criteria: any = {};
    criteria =
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any) => {
        return {
          column: item?.filters?.inputData?.id,
          op: item?.filters?.inputData?.label,
          value: [item?.filters[item?.filters?.inputData?.label]],
        };
      });

    console.log('filter Data', criteria);
    provisionalPageSend('TRIGGER_REFRESH', {
      where: criteria,
    });
  };

  const _renderProvisionalPolicy = () => {
    //console.log("renderpage",provisionalPageState?.event?.data?.value);
    if (provisionalPageState?.matches('GET_PROVISIONAL_POLICY')) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingProvisionalSync()?.loading
            ?.retrieveCredentials || {})}
        />
      );
    }

    if (provisionalPageState?.matches('RENDER_PROVISIONAL_POLICY')) {
      return (
        <>
          {provisionalPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(srv?.agent?.getLoadingProvisionalSync()?.loading
                ?.credentialListEmpty || {})}
            />
          ) : (
            <UsersListComp
              {...(provisionalPageState?.event?.data?.value?.ProvisionalList ||
                {})}
              onViewDetailClick={props?.onViewDetailClick}
              onRowClick={props?.onViewDetailClick}
            />
          )}
        </>
      );
    }
    return null;
  };

  const _renderErrorModals = () => {
    if (provisionalPageState?.matches('RENDER_PROVISIONAL_POLICY_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getErrorProvisionalSync()?.error?.formSubmit || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const _renderHeader = () => {
    if (srv?.agent?.getHeaderProvisionalSync()?.header) {
      return (
        <>
          <Header
            {...(srv?.agent?.getHeaderProvisionalSync()?.header || {})}
            csvData={policyListState?.event?.data?.value?.ultUsers}
            onRefreshClick={onRefresh}
          />
          <SearchFilter
            {...srv?.agent?.getSettingsProvisionalSync()?.settings}
            onFilterApply={onApplyFilter}
            onClearFilter={onClearFilter}
          />
        </>
      );
    }
    return null;
  };

  const _renderPage = () => {
    return (
      <>
        {_renderHeader()}
        {_renderProvisionalPolicy()}
        {_renderPagination()}
        {_renderErrorModals()}
        {_renderNotification()}
      </>
    );
  };
  return <>{_renderPage()}</>;
};
